import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import FITUser from "./FITUser";

const exportReducers = history => {
    return combineReducers({
        router: connectRouter(history),
        FITUser: FITUser
    });
};

export default exportReducers;

